/**
 * @generated SignedSource<<d05bedff22cc808a0b9ca9d93c7a67fd>>
 * @relayHash 3ac76dc0279de00b69bf511b6b1b4501
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0cea9e71aaeedd14691d167f7acf1a7a437b71db5a99c015fd816efa4d2e8f8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e0cea9e71aaeedd14691d167f7acf1a7a437b71db5a99c015fd816efa4d2e8f8",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
